import type { NoiseFilterState } from '@cli-types/next-adapter/utils.js'
import { couldBecomeSuppressible } from './could-become-suppressible.js'
import { filterNoiseLines } from './filter-noise-lines.js'

export function createDrizzleNoiseFilter(forward: (chunk: string) => void): {
  write: (chunk: string) => void
  end: () => void
} {
  const state: NoiseFilterState = {
    suppressingPgSslWarning: false,
    suppressNextTraceHint: false
  }
  let buffer = ''

  return {
    write(chunk: string) {
      buffer += chunk
      const lastNewlineIndex = buffer.lastIndexOf('\n')
      if (lastNewlineIndex !== -1) {
        const complete = buffer.slice(0, lastNewlineIndex + 1)
        buffer = buffer.slice(lastNewlineIndex + 1)
        const filtered = filterNoiseLines(complete, state)
        if (filtered) {
          forward(filtered)
        }
      }

      if (buffer && !couldBecomeSuppressible(buffer, state)) {
        forward(buffer)
        buffer = ''
      }
    },
    end() {
      if (!buffer) {
        return
      }

      const filtered = filterNoiseLines(buffer, state)
      buffer = ''
      if (filtered) {
        forward(filtered)
      }
    }
  }
}
